import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Heading, Text, HStack, VStack, Button, Spinner,
  Badge, Table, Thead, Tbody, Tr, Th, Td,
  Alert, AlertIcon,
} from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';

const API_BASE = '/api/v1';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Token ${localStorage.getItem('token')}`,
});

function Services() {
  const [services, setServices] = useState([]);
  const [namespace, setNamespace] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchServices = useCallback(() => {
    setLoading(true);
    setError(null);
    fetch(`${API_BASE}/k8s/services/`, { headers: getAuthHeaders() })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        setServices(data.services || []);
        setNamespace(data.namespace || '');
        setLoading(false);
      })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  useEffect(() => { fetchServices(); }, [fetchServices]);

  if (loading) return <Box textAlign="center" py={20}><Spinner size="xl" color="gray.500" /></Box>;
  if (error) return <Alert status="error" borderRadius="lg"><AlertIcon />{error}</Alert>;

  return (
    <Box>
      <HStack justify="space-between" mb={6}>
        <VStack align="start" spacing={1}>
          <Heading size="lg">Services</Heading>
          <Text color="gray.500">
            {services.length} services in namespace <Badge colorScheme="blue">{namespace}</Badge>
          </Text>
        </VStack>
        <Button leftIcon={<FiRefreshCw />} colorScheme="gray" onClick={fetchServices}>Refresh</Button>
      </HStack>

      <Box bg="white" borderRadius="lg" boxShadow="md" overflow="hidden">
        <Table variant="simple" size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>Name</Th>
              <Th>Type</Th>
              <Th>Cluster IP</Th>
              <Th>Ports</Th>
              <Th>Selector</Th>
            </Tr>
          </Thead>
          <Tbody>
            {services.map((svc) => (
              <Tr key={svc.name} _hover={{ bg: 'gray.50' }}>
                <Td><Text fontWeight="medium" fontSize="sm">{svc.name}</Text></Td>
                <Td><Badge colorScheme="purple">{svc.type}</Badge></Td>
                <Td><Text fontSize="sm" fontFamily="mono">{svc.cluster_ip}</Text></Td>
                <Td>
                  {(svc.ports || []).map((p, i) => (
                    <Text key={i} fontSize="xs" color="gray.600">
                      {p.port}→{p.target_port} ({p.protocol})
                    </Text>
                  ))}
                </Td>
                <Td>
                  {Object.entries(svc.selector || {}).map(([k, v], i) => (
                    <Badge key={i} colorScheme="gray" fontSize="xs" mr={1}>{k}={v}</Badge>
                  ))}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
}

export default Services;
